import { useCartStore } from '../store/useCartStore';
import { CartItem } from '../types/cart';
import { fetchProductStock } from './useProducts';
import { useToastStore } from '../store/useToastStore';
import { useCartTracking } from './useCartTracking';
import { trackMetaPixelEvent } from '../lib/metaPixel';

export const useAddToCart = () => {
  const { addItem, items: cartItems } = useCartStore();
  const { trackAddToCartEvent } = useCartTracking();
  const { showToast } = useToastStore();

  const addToCart = async (cartItem: CartItem, quantity: number = 1) => {
    const totalStock = await fetchProductStock(parseInt(cartItem.id), 'es');
    const existingItem = cartItems.find((item) => item.id === cartItem.id);
    if (totalStock === 0) {
      showToast('Producto sin stock', 'error');
      return;
    }
    if (existingItem && (quantity > totalStock || existingItem.quantity + quantity > totalStock)) {
      showToast(
        `Stock disponible: ${totalStock - (existingItem?.quantity || 0)} unidad${totalStock !== 1 ? 'es' : ''}`,
        'warning',
        4000
      );
      return;
    }

    // Agregar al carrito
    addItem({ ...cartItem, quantity });

    // Trackear evento de add_to_cart con estructura GA4
    trackAddToCartEvent(cartItem);

    // Meta Pixel: AddToCart
    trackMetaPixelEvent('AddToCart', {
      content_ids: [cartItem.id],
      content_name: cartItem.name,
      content_type: 'product',
      value: cartItem.price,
      currency: 'EUR',
    });
  };

  return { addToCart };
};
